import Axios from "axios";
// import AsyncStorage from "@react-native-community/async-storage";
import { AuthAction } from "../../store/actions";
import { LogisticsRegStore } from "../../store";
// import { NavigationService } from "..";
import variables from "../variables";
import info from "../../components/info";
const { baseUrl } = variables;

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  ({ response }) => {
    console.log(response);
    if (response.status == 401) {
      try {
        window.localStorage.removeItem("logistics_Auth");
        window.localStorage.removeItem("logistics_access_token");

        LogisticsRegStore.dispatch(AuthAction.SignoutSuccess());
        // NavigationService.reset_0("SignIn")

        console.log("%c{Error 401}", "color: red", response);
      } catch (err) { }
    }
    if (response.status == 422) {
      try {
        Object.keys(response.data.errors).map((item) => {
          if (
            response.data.errors[item] !==
            "zipcode entered is not a valid US zipcode"
          ) {
            return info("error", `${item} ${response.data.errors[item]}`);
          }
        });
      } catch (err) { }
    }
    if (response.data.status == 400) {
      try {
        // window.localStorage.removeItem("trkr_Auth").then(() => {
        //     Store.dispatch(AuthAction.SignoutSuccess());
        //     // NavigationService.reset_0("SignIn")
        // })
        if (
          response.data.error.message !== "Linked account is already created"
        ) {
          info("error", `${response.data.error.message}`);
        }
      } catch (err) { }
    }
    return response;
  }
);
Axios.interceptors.request.use(
  function (config) {
    if (localStorage.getItem("logistics_access_token")) {
      config.headers = {
        ...config?.headers,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PATCH, DELETE",
        "Authorization": config?.headers?.abc ? config?.headers?.abc : localStorage.getItem("logistics_access_token")
      };
      return config;
    } else {
      return config;
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default class ApiCaller {
  static Get = (endPoint = "", headers = {}, customUrl = "") => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["Authorization"] = headers["Authorization"];
    }
    return Axios.get(customUrl ? customUrl : `${baseUrl}${endPoint}`, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Post = (endPoint = "", body = {}, headers = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["Authorization"] = headers["Authorization"];
    }
    return Axios.post(`${baseUrl}${endPoint}`, body, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Put = (endPoint = "", body = {}, headers = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["Authorization"] = headers["Authorization"];
    }
    return Axios.put(`${baseUrl}${endPoint}`, body, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Delete = (endPoint = "", headers = {}, body = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["Authorization"] = headers["Authorization"];
    }
    return Axios.delete(`${baseUrl}${endPoint}`, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
      data: body,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
  static Patch = (endPoint = "", headers = {}, body = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["Authorization"] = headers["Authorization"];
    }
    return Axios.patch(`${baseUrl}${endPoint}`, {
      headers,
      data: body,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
}
